<template>
  <div>
    <div align="left" class="mt-4">
      <h4 class="h5 mb-3 text-primary font-weight-bold">Donasi</h4>
    </div>
    <br />
    <b-row>
      <b-col md="8">
        <b-card class="text-left">
          <h5 class="font-weight-bold text-primary">Create New</h5>
          <br />
          <br />
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Code Donation"
                    label-for="input-1"
                  >
                    <input
                      disabled
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="code"
                      data-vv-as="Code Donation"
                      v-model="items.code"
                      placeholder="Code"
                    />
                    <b-form-invalid-feedback id="input-code-feedback">{{ veeErrors.first('code') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Title Bahasa"
                    label-for="input-1"
                  >
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="title_id"
                      data-vv-as="Title Bahasa"
                      v-model="items.title.id"
                      placeholder="Title"
                    />
                    <b-form-invalid-feedback
                      id="input-title_id-feedback"
                    >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Title English"
                    label-for="input-1"
                  >
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="title_en"
                      data-vv-as="Title English"
                      v-model="items.title.en"
                      placeholder="Title"
                    />
                    <b-form-invalid-feedback
                      id="input-title_en-feedback"
                    >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Description Bahasa"
                    label-for="input-1"
                  >
                    <ckeditor
                      :editor="editor"
                      :config="editorConfig"
                      v-model="items.description.id"
                      tag-name="textarea"
                      placeholder="Description Bahasa"
                      v-validate="'required'"
                      name="description_id"
                      data-vv-as="Description English"
                      class="form-control"
                    ></ckeditor>
                    <p
                      class="text-danger"
                      style="width:100%;margin-top:.25rem;font-size: 80%;"
                    >{{ veeErrors.first('description_id') }}</p>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Description English"
                    label-for="input-1"
                  >
                    <ckeditor
                      :editor="editor"
                      :config="editorConfig"
                      v-model="items.description.en"
                      tag-name="textarea"
                      placeholder="Description English"
                      v-validate="'required'"
                      name="description_en"
                      data-vv-as="Description English"
                      class="form-control"
                    ></ckeditor>
                    <p
                      class="text-danger"
                      style="width:100%;margin-top:.25rem;font-size: 80%;"
                    >{{ veeErrors.first('description_en') }}</p>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Donasion Amount"
                    label-for="input-1"
                  >
                    <b-input-group>
                      <template v-slot:prepend>
                        <b-input-group-text>Rp.</b-input-group-text>
                      </template>
                      <input
                        type="text"
                        v-model="items.amount"
                        v-validate="'required|numeric'"
                        name="donasi"
                        data-vv-as="Description Bahasa"
                        tag-name="textarea"
                        placeholder="Enter donation amount here"
                        class="form-control"
                      />
                    </b-input-group>

                    <p
                      class="text-danger"
                      style="width:100%;margin-top:.25rem;font-size: 80%;"
                    >{{ veeErrors.first('donasi') }}</p>
                  </b-form-group>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <b-form-group id="fieldset-1" label="Start Date" label-for="input-1">
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="2"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="items.periode.start_date"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetStardate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="2"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="items.periode.end_date"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetEnddate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row></b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <br />
              <b-row class="text-right">
                <b-col>
                  <b-button variant="primary" @click="put()" :disabled="loading" class="mr-5">Save</b-button>
                  <router-link :to="{name: 'Donasi'}">
                    <b-button variant="outline-secondary">Cancel</b-button>
                  </router-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      selected: "first",
      checked: false,
      modalShow: false,
      file: "",
      widthImage: null,
      heightImage: null,
      url: "",
      title_id: "",
      title_en: "",
      donasi: "",
      period_start: "",
      period_end: "",
      is_always_active: false,
      is_highlight: false,
      counthighlight: null,
      items: [],
      status: [
        { text: "Active", value: "first" },
        { text: "Inactive", value: "second" }
      ],
      button: [
        { text: "No", value: "first" },
        { text: "Yes", value: "second" }
      ],
      options2: [
        { text: "Yes", value: "first" },
        { text: "No", value: "second" }
      ],
      disabledDates: {
        to: new Date(Date.now() - 8672000)
      }
    };
  },
  beforeCreate() {
    this.$store
      .dispatch("DonasiModule/getDonasi", this.$route.params.id)
      .then(response => {
        this.loading = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loading = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.DonasiModule.donasi_id,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    resetStardate() {
      this.items.periode.start_date = "";
    },
    resetEnddate() {
      this.items.periode.end_date = "";
    },
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Donasi!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              const formData = new FormData();

              formData.append("code", this.items.code);
              formData.append("title_id", this.items.title.id);
              formData.append("title_en", this.items.title.en);
              formData.append("description_id", this.items.description.id);
              formData.append("description_en", this.items.description.en);
              formData.append("amount", this.items.amount);
              if (
                this.items.periode.start_date == "" &&
                this.items.periode.end_date != ""
              ) {
                const endDate = moment(this.items.periode.end_date).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", this.items.periode.start_date);
                formData.append("period_end", endDate);
              }
              if (
                this.items.periode.start_date != "" &&
                this.items.periode.end_date == ""
              ) {
                const startDate = moment(this.items.periode.start_date).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", startDate);
                formData.append("period_end", this.items.periode.end_date);
              }
              if (
                this.items.periode.start_date != "" &&
                this.items.periode.end_date != ""
              ) {
                const startDate = moment(this.items.periode.start_date).format(
                  "YYYY-MM-DD"
                );
                const endDate = moment(this.items.periode.end_date).format(
                  "YYYY-MM-DD"
                );

                formData.append("period_start", startDate);
                formData.append("period_end", endDate);
              }
              if (
                this.items.periode.start_date == "" &&
                this.items.periode.end_date == ""
              ) {
                formData.append("period_start", this.items.periode.start_date);
                formData.append("period_end", this.items.periode.end_date);
              }

              this.loading = true;
              this.$store
                .dispatch("DonasiModule/putDonasi", {
                  id: this.$route.params.id,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "Donasi" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your file cant be submit.", "warning");
            }
          });
        }
      });
    }
  }
};
</script>

<style>
</style>
